import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { TruncatedConeGeometry } from '../geometry';
import { Model } from '../core';

var TruncatedCone =
/*#__PURE__*/
function (_Model) {
  _inherits(TruncatedCone, _Model);

  function TruncatedCone(gl) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, TruncatedCone);

    return _possibleConstructorReturn(this, _getPrototypeOf(TruncatedCone).call(this, gl, Object.assign({}, opts, {
      geometry: new TruncatedConeGeometry(opts)
    })));
  }

  return TruncatedCone;
}(Model);

export { TruncatedCone as default };
//# sourceMappingURL=truncated-cone.js.map


//////////////////
// WEBPACK FOOTER
// ./~/luma.gl/dist/esm/models/truncated-cone.js
// module id = 636
// module chunks = 0